import * as React from 'react';

import {RichTextarea} from 'shells/rich-textarea/rich-textarea';

import styles from './rich-textarea-email.module.css';

type Props = {
    bodyHtml: string;
};

/* Component responsible for rendering a personal email
 * interaction inside of a modal. This is different from
 * a personal email since it's in the context of a reaction
 * and therefore has fewer bells and whistles
 */
export function RichTextareaEmail(props: Props) {
    return (
        <div className={styles['rich-textarea-email']}>
            <RichTextarea
                id='expanded-content--rich-textarea'
                value={props.bodyHtml}
                readOnly={true}
                noPadding={true}
                config={{
                    modules: {
                        toolbar: false,
                    },
                    formats: ['bold', 'italic', 'list', 'image'],
                    images: true,
                    formatLinks: true,
                    useDivs: true,
                    placeholders: false,
                }}
            />
        </div>
    );
}
